<template>
  <div >
    <el-dialog
      :title="$t('addUserDialog.title')"
      :visible="true"
      :before-close="onClose"
      width="90%">
      <el-steps
        :space="300"
        :active="step"
        finish-status="success"
        align-center
        style="justify-content: center;">
        <el-step title="Profil"></el-step>
        <el-step title="Mot de passe"></el-step>
        <el-step title="Terminé"></el-step>
      </el-steps>
      <UserProfileForm
        v-if="step === 0"
        @onSave="handleUserProfile"
        :saveButtonText="$t('addUserForm.submitButtonText')"
        titleEditable
        roleEditable
        :userProfile="userProfile"/>
      <UserPasswordForm
        v-if="step === 1"
        v-loading="addingUserLoading"
        :saveButtonText="$t('addUserForm.submitPasswordButtonText')"
        :cancelButtonText="$t('addUserForm.cancelPasswordFormButtonText')"
        @canceled="step = 0"
        @submited="handlePassword"/>
    </el-dialog>
  </div>
</template>
<script>
import services from 'services';
import UserProfileForm from '@/components/Forms/UserProfileForm.vue';
import UserPasswordForm from '@/components/Forms/UserPasswordForm.vue';

export default {
  components: { UserProfileForm, UserPasswordForm },
  data() {
    return {
      userProfile: {},
      userPassword: {},
      step: 0,
      addingUserLoading: false,
    };
  },
  methods: {
    onClose() {
      this.$emit('close');
    },
    handleUserProfile(userProfile) {
      this.userProfile = userProfile;
      this.step = 1;
    },
    handlePassword({ password }) {
      this.userPassword = password;
      this.createUser(this.userProfile, this.userPassword);
    },
    async createUser(userProfile, userPassword) {
      this.addingUserLoading = true;
      const shopId = this.$store.getters['shopAuth/authenticatedShopId'];
      const userService = new services.UserService(this.$store.getters['auth/authenticatedUserIdToken']);
      const user = await userService.createShopUser(
        userProfile,
        userPassword,
        shopId,
      );
      this.addingUserLoading = false;
      this.$message.success({ message: "L'utilisateur a été ajouté" });
      this.$emit('onUserAdded', user);
      this.onClose();
    },
  },
};
</script>
<style lang="stylus" scoped>
</style>
